import React from 'react';
import { Box, Text, Stack, HStack, Divider } from "@chakra-ui/react";
import PrimaryButton from '../../components/themeComponents/PrimaryButton';
import PlatformWidget from '../../components/themeComponents/PlatformWidget';
import LightspeedR from "../../images/Lightspeed-R.png";
import { useOutletContext } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function LightSpeed() {
  const { integration } = useOutletContext();
  const { t } = useTranslation();

  const WidgetContent = () => (
    <Stack justifyItems={'space-around'}  >
      <Text fontSize={'xl'} width={'60%'} my={'5px'} >{t('lightspeed.description')}</Text>
      <PrimaryButton width={'8vw'} marginTop={'5px'} type={'submit'} borderRadius={'8px'} height={'1.8vh'} padding={'1vw 1vw'} fontSize={'0.8vw'} label={t('lightspeed.connect')} />
    </Stack>
  )

  return (
    <>
      <Box width={'100%'} bg={'#fff'} borderRadius={'1vw'} display={'flex'} flexDirection={'column'} p={'1rem'} justifyContent={'center'} alignItems={'center'} >
        <Box alignItems={'baseline'} display={'flex'} flexDirection={'column'} gap={'1vh'} width={'100%'} >
          <PlatformWidget platform={
            {
              title: t('lightspeed.title', { entityName: integration.entityName }),
            }
          }
            icon={LightspeedR}
            WidgetContent={WidgetContent}

          />

          <Text fontSize={'xl'} pl={'3%'} color={'#AD88F1'} >{t('lightspeed.stepsTitle')}</Text>
          <HStack paddingLeft={'4.5%'} gap={'1vw'} width={'100%'}  >
            <Divider border={'1px solid #dadada'} orientation='vertical' height={'20vh'} />
            <Stack>
              <Stack p={'2rem'} >

                <Text color={'#7746A6'} >{t('lightspeed.steps.step1')}</Text>
                <Text color={'#7746A6'} >{t('lightspeed.steps.step2')}</Text>

              </Stack>
              <Text color={'#7746A6'} >{t('lightspeed.queries', { entityName: integration.entityName })}</Text>
            </Stack>
          </HStack>
        </Box>
      </Box>
    </>
  );
}
